var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "youtube-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "youtube",
    transform: "translate(-1.000000, 13.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.6462523,10.7931309 C87.6083654,6.93901328 84.5688394,3.90018975 80.7138309,2.86254269 C73.6710269,0.935483871 45.4998109,0.935483871 45.4998109,0.935483871 C45.4998109,0.935483871 17.3285948,0.935483871 10.2857908,2.78842505 C6.5049171,3.82607211 3.39125638,6.93901328 2.35336948,10.7931309 C0.5,17.8343074 0.5,32.4354839 0.5,32.4354839 C0.5,32.4354839 0.5,47.110778 2.35336948,54.0778368 C3.39125638,57.9319545 6.43078232,60.970778 10.2857908,62.008425 C17.4027296,63.9354839 45.4998109,63.9354839 45.4998109,63.9354839 C45.4998109,63.9354839 73.6710269,63.9354839 80.7138309,62.0825427 C84.5688394,61.0448956 87.6083654,58.0060721 88.6462523,54.1519545 C90.5,47.110778 90.5,32.5096015 90.5,32.5096015 C90.5,32.5096015 90.5737565,17.8343074 88.6462523,10.7931309 Z",
    id: "Path",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "37.5 46.9354839 60.5 33.4354839 37.5 19.9354839"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.2aa48cba67b290217136264c27baa501.svg";
export { ForwardRef as ReactComponent };